require("./bootstrap");
import Vue from "vue";
import vuetify from "./vuetify";
import VuetifyDialog from "vuetify-dialog";
import "vuetify-dialog/dist/vuetify-dialog.css";

Vue.use(VuetifyDialog, {
    context: {
        vuetify,
    },
});

Vue.component("xp-home", require("./views/home/index.vue").default);
Vue.component("xp-clients", require("./views/clients/index.vue").default);
Vue.component("xp-contacts", require("./views/contacts/index.vue").default);
Vue.component("xp-services", require("./views/services/index.vue").default);
Vue.component("xp-about", require("./views/about/index.vue").default);
Vue.component("xo-toolbar", require("./components/Toolbar.vue").default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

const app = new Vue({
    el: "#app",
    vuetify,
});
